import { Loading } from 'element-ui';

export function secondToDate(result) {
  var h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
  var m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
  var s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
  if (h == 0 && m == 0) {
    return `${parseInt(s)}s`;
  }
  if (h == 0) {
    return `${m}m ${s}s`;
  }
  return `${h}h ${m}m ${s}s`;
}

/**
 * 转存储单位
 * @param {*} size byte 
 */
export function getSize(size) {
  if (size >= 0 && size < 1024) {
    return `${size} Byte`
  } else if (size >= 1024 && size < 1024 * 1024) {
    return `${(size / 1024).toFixed(2)}KB`
  } else if (size >= 1024 * 1024 && size < 1024 * 1024 * 1024) {
    return `${(size / 1024 / 1024).toFixed(2)}MB`
  } else if (size >= 1024 * 1024 * 1024) {
    return `${(size / 1024 / 1024 / 1024).toFixed(2)}GB`
  }
  return '未知大小'
}

export function isIos() {
  return /(iphone|itouch|ipad)/.test(navigator.userAgent.toLowerCase())
}

/**
 * 时间转换(默认保留两位小数)
 */
export function timeConversion(time) {
  let result = ''
  time = parseInt(time)
  if (!isNaN(time)) {
    if (time < 60) {
      if (time < 10) {
        time = '0' + time
      }
      result = `00:${time}`
    } else if (time >= 60) {
      let h = Math.floor(time / 3600)
      let min = Math.floor((time - h * 3600) / 60)
      let sec = time % 60

      if (h < 10) {
        h = '0' + h
      }
      if (min < 10) {
        min = '0' + min
      }
      if (sec < 10) {
        sec = '0' + sec
      }
      result = `${min}:${sec}`

      if (time >= 3600) {
        result = `${h}:${min}:${sec}`
      }
    }
  } else {
    result = '--:--'
  }
  return result
}

/**
 * 将内容写入剪切板
 * @param {*} text 要复制的内容
 */
export function copyContent(text) {
  let target = null;
  target = document.createElement('div');
  target.id = 'tempTarget';
  target.style.opacity = '0';
  target.innerText = text;
  document.body.appendChild(target);

  try {
    let range = document.createRange();
    range.selectNode(target);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    document.execCommand('copy');
    window.getSelection().removeAllRanges();
  } catch (e) {
    return false
  }
  target.parentElement.removeChild(target);
  return true
}

/**
 * loading加载状态
 * @param {*} type 1.loading 0.close loading
 */
let load = null
export function loading(type) {
  if (type === 1) {
    load = Loading.service({
      text: "加载中, 请耐心等待...",
      background: 'rgba(0, 0, 0, 0.7)'
    });
  } else {
    load.close()
  }
}

/**
 * 上传文件到oss
 */
export function upload(file, fileFormat, name, size) {
  new Promise((resolve, reject) => {

  })
}

/**
 * 判断价格是否按规则设置
 */
export function checkPrice(form) {
  let bool = true
  const resolution = form.resolution
  if (resolution == 2) {
    bool = bool && form.firstPrice > form.transcode2kPrice
    if (form.haveSetDisPrice) {
      bool = bool && form.firstPrice > form.discountPrice
      bool = bool && form.transcode2kPrice > form.disTranscode2kPrice
    }
    if (form.haveSetMemDisPrice) {
      bool = bool && form.discountPrice > form.disProPrice > form.disAdvPrice > form.disBnsPrice
      bool = bool && form.disProPrice > form.disProTranscode2kPrice
      bool = bool && form.disAdvPrice > form.disAdvTranscode2kPrice
      bool = bool && form.disBnsPrice > form.disBnsTranscode2kPrice
    }
  }
}